import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FiHome,
  FiFileText,
  FiPackage,
  FiClipboard,
  FiBarChart2,
  FiLogOut,
} from "react-icons/fi";
import Swal from "sweetalert2"; 
import logo from  "../assets/img/logo.webp";


function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };



const handleLogout = () => {
  Swal.fire({
    title: "Are you sure?",
    text: "You will be logged out of your account.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, logout",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      // Clear session and redirect
      localStorage.removeItem("customer_id");
      localStorage.removeItem("token");

      Swal.fire({
        title: "Logged Out",
        text: "You have been successfully logged out.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate("/");
      }, 1500);
    }
  });
};

  return (
    <aside className="sidebar-wrapper">
      <div className="sidebar-header">
        <div className="logo-name flex-grow-1">
          {/* <h5 className="mb-0">MediInvoice</h5> */}
          <img src={logo} className="img-fluid my-3" style={{maxHeight: "60px"}} />
        </div>
        <div className="sidebar-close">
          <span className="material-icons-outlined">close</span>
        </div>
      </div>

      <div className="sidebar-nav">
        <ul className="sidenav">
          {/* Dashboard */}
          <li>
            <Link
              to="/dashboard"
              className={location.pathname === "/dashboard" ? "active" : ""}
            >
              <div className="parent-icon">
                <FiHome size={20} />
              </div>
              <div className="menu-title">Dashboard</div>
            </Link>
          </li>

          {/* Pharmacy */}
          <li className={`dropdown ${openMenu === "pharmacy" ? "open" : ""}`}>
            <button
              className="dropdown-toggle"
              onClick={() => toggleMenu("pharmacy")}
            >
              <div className="parent-icon">
                <FiPackage size={20} />
              </div>
              <div className="menu-title">Pharmacy</div>
              <span className="material-icons-outlined arrow">
                {openMenu === "pharmacy" ? "expand_less" : "expand_more"}
              </span>
            </button>
            <ul className="submenu">
              <li>
                <Link
                  to="/add-medicine"
                  className={
                    location.pathname === "/add-medicine" ? "active" : ""
                  }
                >
                  <FiClipboard size={16} className="me-2" /> Add Medicine
                </Link>
              </li>
              <li>
                <Link
                  to="/all-medicine"
                  className={
                    location.pathname === "/all-medicine" ? "active" : ""
                  }
                >
                  <FiFileText size={16} className="me-2" /> All Medicine
                </Link>
              </li>

<li>
                <Link
                  to="/stock-med"
                  className={
                    location.pathname === "/stock-med" ? "active" : ""
                  }
                >
                  <FiFileText size={16} className="me-2" /> Stock Medicine
                </Link>
              </li>
             

           


            </ul>
          </li>

          {/* Invoice */}
          <li className={`dropdown ${openMenu === "invoice" ? "open" : ""}`}>
            <button
              className="dropdown-toggle"
              onClick={() => toggleMenu("invoice")}
            >
              <div className="parent-icon">
                <FiClipboard size={20} />
              </div>
              <div className="menu-title">Invoice</div>
              <span className="material-icons-outlined arrow">
                {openMenu === "invoice" ? "expand_less" : "expand_more"}
              </span>
            </button>
            <ul className="submenu">
              <li>
                <Link
                  to="/add-invoice"
                  className={
                    location.pathname === "/add-invoice" ? "active" : ""
                  }
                >
                  <FiClipboard size={16} className="me-2" /> Add Invoice
                </Link>
              </li>
              <li>
                <Link
                  to="/all-invoice"
                  className={
                    location.pathname === "/all-invoice" ? "active" : ""
                  }
                >
                  <FiFileText size={16} className="me-2" /> All Invoice
                </Link>
              </li>
            </ul>
          </li>

          {/* Reports */}
          <li className={`dropdown ${openMenu === "report" ? "open" : ""}`}>
            <button
              className="dropdown-toggle"
              onClick={() => toggleMenu("report")}
            >
              <div className="parent-icon">
                <FiBarChart2 size={20} />
              </div>
              <div className="menu-title">Reports</div>
              <span className="material-icons-outlined arrow">
                {openMenu === "report" ? "expand_less" : "expand_more"}
              </span>
            </button>
            <ul className="submenu">
              <li>
                <Link
                  to="/invoice-report"
                  className={
                    location.pathname === "/invoice-report" ? "active" : ""
                  }
                >
                  <FiFileText size={16} className="me-2" /> Invoice Report
                </Link>
              </li>
              <li>
                <Link
                  to="/medicine-report"
                  className={
                    location.pathname === "/medicine-report" ? "active" : ""
                  }
                >
                  <FiPackage size={16} className="me-2" /> Medicine Report
                </Link>
              </li>

              <li>
                <Link
                  to="/return-report"
                  className={
                    location.pathname === "/return-report" ? "active" : ""
                  }
                >
                  <FiPackage size={16} className="me-2" /> Return Report
                </Link>
              </li>


              <li>
                <Link
                  to="/revenue-report"
                  className={
                    location.pathname === "/revenue-report" ? "active" : ""
                  }
                >
                  <FiPackage size={16} className="me-2" /> Revenue Report
                </Link>
              </li>

 

            </ul>
          </li>

          {/* Logout */}
          <li>
            <button onClick={handleLogout} className="btn ">
              <div className="parent-icon">
                <FiLogOut size={20} />
              </div>
              <div className="menu-title">Logout</div>
            </button>
          </li>
        </ul>
      </div>
    </aside>
  );
}

export default Sidebar;
